import { Component, OnInit, Input, EventEmitter, Output, ChangeDetectorRef, ChangeDetectionStrategy, OnChanges, ViewChild, ViewChildren, QueryList } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';


@Component({
    selector: 'app-nr-tables',
    templateUrl: './nr-tables.component.html',
    styleUrls: ['./nr-tables.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class NrTablesComponent implements OnInit, OnChanges {

  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  @ViewChildren('sortTh') sortElement: QueryList<any>;

  @Input() isRowClickable = false;
  @Input() columnHeader = []
  @Input() columnRowData = [];
  @Input() showUtils = false;
  @Input() showCheckbox = false;
  @Input() pageSize: number = 10;
  @Output() selectedRowEvent = new EventEmitter();

  columnRowDataBackup = [];

  index;
  splicedData = [];
  defaultSort = true;
  showLoader = false;
  display = "none";
  searchLabel: any;
  searchText = '';

  pageIndex: number = 0;
  lowValue: number = 0;
  highValue: number = 10;
  pageSizeOptions: number[] = [5, 10, 25, 100];

  topPosition: string;
  leftPosition: string;
  objPosition: { top: any; left: any; };
  showFilterPopUp = false;
  showResetFilter = false;
  selectedHeaderIndex = null;
  constructor(private cdr: ChangeDetectorRef) { }
  ngOnChanges(): void {
    this.columnRowDataBackup = [...this.columnRowData];
    this.spliceData();
    setTimeout(() => {
      this.paginationPageSet();
    }, 500)
  }

  ngOnInit(): void {
    this.columnRowDataBackup = [...this.columnRowData];
    this.spliceData();
  }


  spliceData() {
    const pc = this.pageIndex + 1;
    const offset = ((this.pageIndex + 1) - 1) * this.pageSize;
    // console.log(this.pageSize,offset,this.columnRowData.slice(offset ,(this.pageSize*pc)));
    // this.splicedData = this.columnRowData.slice(((0 + 1) - 1) * this.pageSize).slice(0, this.pageSize);
    this.splicedData = this.columnRowData.slice(offset, (this.pageSize * pc));
  }

  getData(data, colName) {
    if (typeof data[colName] === 'object' && data[colName] !== null) {
      return this.getData(data[colName], colName);
    }
    return data[colName];
    // return "";
  }

  sortData(ev) {
    this.showLoader = true;
    this.defaultSort = !this.defaultSort;
    this.columnRowData.sort(this.dynamicSort(ev['id']));
    this.spliceData();
    this.showLoader = false;
    this.showFilterPopUp = false;
  }

  dynamicSort(prop) {
    let sortOrder = 1;
    if (!this.defaultSort) {
      sortOrder = -1;
    }

    return (a, b) => {
      let result = (a[prop] < b[prop]) ? -1 : (a[prop] > b[prop]) ? 1 : 0;
      return result * sortOrder;
    }
  }

  dynamicContent(col) {
    try {
      return col.template.templateContent;
    }
    catch (e) {
      return false;
    }
  }

  selectedRowDetails(data) {
    if (this.isRowClickable) {
      this.selectedRowEvent.emit(data);
    }
  }

  checkOrUncheckSelected(data, event) {
    this.selectedRowEvent.emit({ data, isChecked: event });
  }

  showFilter(e, header, index) {
    e.stopPropagation();
    if (header.isSearchable) {
      this.spliceData();
      this.searchLabel = header;
      this.selectedHeaderIndex = index;
      const srdArr = this.sortElement.toArray();
      if (this.sortElement && srdArr.length) {
        const parentPosition = srdArr[index].nativeElement.getBoundingClientRect();
        const lefPos = parentPosition.right;
        const topPos = parentPosition.bottom;

        const bufferTop = -2;
        const bufferLeft = 131;
        const windowTop = window.scrollY + bufferTop;
        this.topPosition = (windowTop + topPos) + 'px';
        this.leftPosition = (lefPos - bufferLeft) + 'px';

        this.objPosition = { top: this.topPosition, left: this.leftPosition };

        this.showFilterPopUp = true;

      }
    }

  }

  tableSearch(event) {
    const searchParam = this.searchLabel.id;
    if (event) {
      // this.resetFilterHeader();
      this.columnHeader[this.selectedHeaderIndex]['isFilterd'] = true;
      // this.columnRowData =[...this.columnRowDataBackup
      // .filter(el => el[searchParam].toLowerCase().includes(event.toLowerCase()))];
      // this.splicedData = this.columnRowData
      //                   .filter(el => el[searchParam].toLowerCase().includes(event.toLowerCase()))
      //                   .slice(((0 + 1) - 1) * this.pageSize).slice(0, this.pageSize);


      this.columnRowData = [...this.columnRowDataBackup
        .filter(el => event.includes(el[searchParam]))];

      this.splicedData = this.columnRowData
        .filter(el => event.includes(el[searchParam]))
        .slice(((0 + 1) - 1) * this.pageSize).slice(0, this.pageSize);
      this.showFilterPopUp = false;
      this.spliceData();
      this.paginationPageSet();
      this.showResetFilter = true;

    } else {
      this.spliceData();
    }
    this.cdr.detectChanges();
  }

  paginationPageSet() {
    if (this.paginator) {
      this.paginator.firstPage();
      this.paginator.length = this.columnRowData.length;
    }
  }


  closeFilter(e) {
    this.showFilterPopUp = false;
  }

  getColumnLength() {
    if (this.showCheckbox) {
      return this.columnHeader.length + 1;
    } else {
      return this.columnHeader.length;
    }
  }

  selectedRow(event) {
    console.log(event);
  }

  resetFilterHeader() {
    this.columnHeader.forEach(header => {
      header['isFilterd'] = false;
    });
    this.columnHeader = [...this.columnHeader];
    this.showResetFilter = false;
  }

  resetGrid() {
    this.resetFilterHeader();
    this.columnRowData = [...this.columnRowDataBackup];
    this.spliceData();
  }

  getPaginatorData(event) {
    this.showLoader = true;
    this.pageSize = event.pageSize;
    const offset = ((event.pageIndex + 1) - 1) * event.pageSize;
    this.pageIndex = (event.pageIndex);
    // this.splicedData = this.columnRowData.slice(offset).slice(0, event.pageSize);
    this.spliceData()
    this.showLoader = false;
  }

}
